import React from 'react';

const EotCampDirector = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/eot-camp-director.html"
        title="Eot camp director app"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default EotCampDirector;